import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form } from 'formsy-react'
import moment from 'moment'
import styled from 'styled-components'
import { Button, DatePicker } from 'advenio-components'
import IncidentActions from '../../Data/Redux/IncidentRedux'
import { ReportHeader, ReportContainer } from '../../Components/ReportsComponents'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${props => props.large ? 'row' : 'column'};
  padding: 16px;
  width: ${props => props.large ? '648px' : '400px'};
`

class Incident extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      start_date: null,
      end_date: null,
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  onChange = (model) => {
    this.setState({ start_date: model.start_date, end_date: model.end_date })
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  download = () => {
    const { start_date, end_date} = this.state
   
    if(start_date === null  || end_date === null){
      return false
    }
   
    if (this.props.fromCenter) {
      this.props.getCentersIncidentExcel(
        this.state.start_date, this.state.end_date, this.props.activeCenter)
    } else {
      this.props.getIncidentExcel(this.state.start_date, this.state.end_date)
    }
  }

  render() {
    const { width } = this.state
    return (
      <ReportContainer>
        <ReportHeader>
          <span>Reporte de incidencias</span>
        </ReportHeader>
        <Form
          onChange={this.onChange}
        >
          <Container large={width > 768}>
            <DatePicker
              name="start_date"
              label="Fecha inicio"
              // style={{ marginRight: '5px' }}
              // value={moment().subtract(1, 'months').format('YYYY-MM-DD')}
            />
            <DatePicker
              name="end_date"
              label="Fecha Fin"
              // value={moment().format('YYYY-MM-DD')}
            />
            <Button marginRight="0" marginLeft="0" danger small onClick={this.download}>
              Descargar
            </Button>
          </Container>
        </Form>
      </ReportContainer>
    )
  }
}


const mapStateToProps = ({ centersInfo }) => ({
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getIncidentExcel: (start_date, end_date) =>
    dispatch(IncidentActions.IncidentRequest(start_date, end_date)),
  getCentersIncidentExcel: (start_date, end_date, id) =>
    dispatch(IncidentActions.CentersIncidentRequest(start_date, end_date, id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Incident))



// WEBPACK FOOTER //
// ./src/Containers/Reports/Incident.jsx